"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var temp = function FundTwoTone(primaryColor, secondaryColor) {
  return {
    name: 'fund',
    theme: 'twotone',
    nameWithTheme: 'fund-twotone',
    tag: 'svg',
    attrs: {
      xmlns: 'http://www.w3.org/2000/svg',
      class: 'icon',
      viewBox: '0 0 1024 1024'
    },
    children: [{
      tag: 'path',
      attrs: {
        fill: primaryColor,
        d: 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560z'
      },
      children: []
    }, {
      tag: 'path',
      attrs: {
        fill: secondaryColor,
        d: 'M136 792h752V232H136v560zm56.4-130.5l214.9-215c3.1-3.1 8.2-3.1 11.3 0L533 561l254.5-254.6c3.1-3.1 8.2-3.1 11.3 0l36.8 36.8c3.1 3.1 3.1 8.2 0 11.3l-297 297.2c-3.1 3.1-8.2 3.1-11.3 0L412.9 537.2 240.4 709.7c-3.1 3.1-8.2 3.1-11.3 0l-36.7-36.9c-3.1-3.1-3.1-8.2 0-11.3z'
      },
      children: []
    }, {
      tag: 'path',
      attrs: {
        fill: primaryColor,
        d: 'M229.1 709.7c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8c-3.1-3.1-8.2-3.1-11.3 0L533 561 418.6 446.5c-3.1-3.1-8.2-3.1-11.3 0l-214.9 215c-3.1 3.1-3.1 8.2 0 11.3l36.7 36.9z'
      },
      children: []
    }]
  };
};
temp.nameWithTheme = 'fund-twotone';
var FundTwoTone = temp;
exports.default = FundTwoTone;